const hasImages = post => post.images && post.images.length
const hasTags = post => post.tags && post.tags.length
// TODO: this will change when we make images field handling the same across all entities (the post image mapping will be wrong/not needed)
const images = post => (hasImages(post) && post.images) || (hasTags(post) && hasImages(post.tags[0]) && post.tags[0].images) || undefined
const postImages = (post) => {
	const resultImages = [(hasImages(post) && post.images), (hasTags(post) && hasImages(post.tags[0]) && post.tags[0].images)].filter(imgs => !!imgs)
	return resultImages.length > 0 ? resultImages : undefined
}
export default { hasImages, hasTags, images, postImages }

export { hasImages, hasTags, images, postImages }



// WEBPACK FOOTER //
// ./src/utilities/Data/Post/internal.js